var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.gameState.inSectModal
    ? _c("div", { staticClass: "sect-modal", on: { click: _vm.closeModal } }, [
        _c(
          "div",
          {
            staticClass: "sect-card",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "sect-content" }, [
              _c(
                "div",
                { staticClass: "sect-list" },
                _vm._l(_vm.availableSects, function (sect) {
                  return _c(
                    "button",
                    {
                      key: sect.name,
                      staticClass: "sect-button",
                      class: {
                        "current-sect-btn": _vm.gameState.sect === sect.name,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.joinSect(sect.name)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "sect-name" }, [
                        _vm._v(_vm._s(sect.name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "sect-description" }, [
                        _vm._v(_vm._s(sect.description)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sect-bonuses" },
                        _vm._l(sect.bonuses, function (bonus) {
                          return _c(
                            "div",
                            { key: bonus, staticClass: "sect-bonus" },
                            [_vm._v(_vm._s(bonus))]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.gameState.sect === sect.name
                        ? _c("div", { staticClass: "current-sect" }, [
                            _vm._v("当前宗门"),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sect-footer" }, [
              _c(
                "button",
                {
                  staticClass: "close-btn",
                  on: { click: _vm.handleCloseClick },
                },
                [_vm._v("关闭")]
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sect-header" }, [
      _c("h3", [_vm._v("选择宗门")]),
      _vm._v(" "),
      _c("p", [_vm._v("加入宗门可以获得宗门特有的修炼资源和技能传承。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }